import React from 'react';
import OverlayWrapper, { ExportedOverlayProps } from '../../../modules/common/OverlayWrapper';
import Tooltip, { TooltipProps, TooltipValueProps } from '../Tooltip';
import InternalButtonTooltip from './ButtonTooltip';
import { ButtonTooltipProps, ButtonTooltipValueProps as InternalButtonTooltipValueProps } from './types';

export type { ButtonTooltipProps }; // MANUAL OVERRIDE

// MANUAL OVERRIDE
export type ButtonTooltipValueProps = ExportedOverlayProps<
TooltipValueProps & TooltipProps,
InternalButtonTooltipValueProps
>;

// MANUAL OVERRIDE
const ButtonTooltip: React.FC<ButtonTooltipValueProps> = (props) => (
  <OverlayWrapper
    {...props}
    Content={Tooltip}
    Target={InternalButtonTooltip}
  />
);

export default ButtonTooltip;
